import { useRouter } from 'next/router'
import React from 'react'

interface FreeLimitPopupProps {
  heading: string
  title: JSX.Element
  createAccountButton?: boolean
  premiumSignupButton?: boolean
  cssModified?: boolean
}

const FreeLimitPopup: React.FC<FreeLimitPopupProps> = ({
  heading,
  title,
  createAccountButton = true,
  premiumSignupButton = true,
  cssModified = false,
}) => {
  const router = useRouter()
  const handleCreateAccount = () => {
    router.push('/signup/')
  }
  const handlePremiumSignup = () => {
    window.open('https://hub.legaltechnologyhub.com/more-info', '_blank')
  }
  return (
    <div className={`popup-rectangle ${cssModified ? 'last-article-rectangle' : ''}`}>
      <div className={`pop-container ${cssModified ? 'last-article-container' : ''}`}>
        <h2 className="popup-heading">{heading}</h2>
        <div className="popup-body">
          <p className="popup-title">{title}</p>
          <div className="popup-button">
            {createAccountButton && (
              <button
                className="text-white py-2 px-12 mr-4 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                onClick={handleCreateAccount}
              >
                Create an Account
              </button>
            )}
            {premiumSignupButton && (
              <button
                className="text-white py-2 px-12 font-secondary text-[14px] font-bold text-center h-[50px] !important bg-navy rounded-[25px] w-[247px]"
                onClick={handlePremiumSignup}
              >
                Sign Up for Premium
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FreeLimitPopup
